import Grid from '@mui/material/Grid';


export default function SectionStructure(props) {

    const {sectiontext, sectiondiagroup, sectioncards, sectioncardsxl} = props

return (
    <>

<Grid container sx={{p: {sm:'2em'}, width: '100%'}}>
  
    <Grid size={{xs:12, xl:4}}> 

        <Grid container sx={{width: '100%'}}>
            <Grid size={12} display='flex' justifyContent='center' alignItems= 'flex-start' sx={{pl:4, pt:{xs: '1em', lg: '2em'}, }}> {sectiontext} </Grid>
            <Grid size={12} display='flex' justifyContent='center' alignItems= 'flex-start' sx={{mt:0.5 }}> {sectiondiagroup} </Grid>
         </Grid>

   </Grid>
    
    
        <Grid size={{xs:12, xl:8}} display='flex' justifyContent={{xs:'center'}} alignItems='flex-start' sx={{ p:{xs: '1em', lg: '4em',}, }}> 
                    {sectioncards}
        </Grid>
        <Grid size={{xs:12}} display='flex' justifyContent={{xs:'center'}} alignItems='flex-start' sx={{ p:{xs: '2em', lg: '0em',}, }}> 
                    {sectioncardsxl}
        </Grid>

    </Grid>

</>
)
}